<script>
import {VueFinalModal} from "vue-final-modal";
import ModalKkMixin from "@/components/conversation-club/modal-kk-mixin.js";
import ImagePicker from "@/components/oj/image-picker.vue";
import axios from "axios";
import {toast} from "vue3-toastify";
import FilePicker from "../file-picker.vue";
export default {
  name: "chapter-form",
  props:['chapter'],
  mixins: [ModalKkMixin],
  components: {VueFinalModal, ImagePicker, FilePicker},
  data(){
    return {

      image_path: null
    }
  },
  mounted() {

  },
  watch:{
    chapter(){
      this.imgsrc = `https://editor.onlinejazyky.cz${this.chapter.image}`
    }
  },

  methods:{
    onImageChange(f){
      this.chapter.image = f
      this.imgsrc = f
    },

    handleSaveChanges() {
      const formData={
        chapter:{
          name: this.chapter.name,
          description: this.chapter.description,
          image: this.chapter.image
        }
      }
      if (this.chapter.id) {
        axios.put(`/oj/chapters/${this.chapter.id}`, formData).then(response => {

          this.$emit('chapterUpdated')
          this.hideModal()
          toast.success('Kapitola byla upravena')
        }).catch(e=>{

          toast.error(e.response.data.errors)

        })
      }else{
        axios.post(`/oj/courses/${this.chapter.course_id}/chapters`, formData).then(response => {

          this.$emit('chapterUpdated')
          this.hideModal()
          toast.success('Kapitola byla vytvorena')
        }).catch(e=>{

          toast.error(e.response.data.errors)

        })
      }


    }

  }
}
</script>

<template>
  <vue-final-modal v-model="showM" classes="modal-container" content-class="modal-content-f w800">
    <div class="modal-header">
      <b>Kapitola</b> {{this.chapter.id}}
      <button type="button" class="close" @click.prevent="hideModal" aria-label="Close">
        <span aria-hidden="true">&times;</span>
      </button>
    </div>

    <div class="modal__content">
      <div class="form-group">
        <label>Název</label>
        <input type="text" v-model="chapter.name" class="form-control"/>
      </div>



      <div class="form-group">
        <label>Popis</label>
        <textarea v-model="chapter.description" class="form-control"></textarea>
      </div>



      <div class="form-group">
        <label>Obrázek</label>
        <image-picker @imageChange="onImageChange" :src="chapter.image"></image-picker>

      </div>
    </div>
    <div class="modal-footer">
      <button @click="handleSaveChanges">Ulož změny</button>
    </div>

  </vue-final-modal>
</template>

<style scoped>


</style>